import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AuthService } from '../../../../services/auth.service';
import { OrderTypes } from '../../../../enums/order-types';
import { Pages } from '../../../../enums/pages';
import { SearchService } from '../../../../services/search.service';
import { OrderService, StateChange } from '../../../../services/order.service';
import { GoogleAnalytics } from '../../../../services/google-analytics.service';

const MIN_SYMBOLS_TO_SEARCH = 3;

@UntilDestroy()
@Component({
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HeaderSearchComponent implements OnInit {
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  orderTypes = [
    { id: OrderTypes.ECOMMERCE_TYPE, label: 'On Demand' },
    { id: OrderTypes.PREORDER_TYPE, label: 'Buying Window' },
  ];

  searchText = '';

  // selectedOrderType = ECOMMERCE_TYPE;
  //  currentPage: Pages;

  @Input() set pageType(val: Pages) {
    // this.currentPage = val;
    //
    // if ( this.currentPage === Pages.BuyingWindowPage) {
    //   this.selectedOrderType = PREORDER_TYPE;
    // } else if ( this.currentPage === Pages.OnDemand) {
    //   this.selectedOrderType = ECOMMERCE_TYPE;
    // }
  }

  constructor(
    private authService: AuthService,
    private searchService: SearchService,
    private orderService: OrderService,
    private googleAnalytics: GoogleAnalytics,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.searchService
      .shouldUpdateSearchTextChanged()
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        if (result) {
          this.searchText = this.searchService.globalTerm;
          this.searchService.setOnUpdateSearchText(false);
        }
      });
  }

  get canChooseOrderType(): boolean {
    return this.authService.canBuyingWindow;
  }

  onSelectOrderType(orderType: { id: string; label: string }): void {
    this.orderService.setState({
      eventChange: StateChange.CurrentOrderType,
      currentOrderType: orderType.id,
    });

    this.searchInput.nativeElement.focus();
    this.search();
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.search();
    }

    if (e.key === 'Escape') {
      // exit from search mode
      this.searchText = '';
    }
  }

  onSearch(): void {
    this.search();
  }

  onClearSearch(): void {
    this.searchText = '';
  }

  private search(): void {
    if (
      this.searchText &&
      this.searchText.trim().length >= MIN_SYMBOLS_TO_SEARCH
    ) {
      const term = this.searchText.trim();
      const orderType = this.selectedOrderType;
      const page = this.router.url;

      this.searchService.globalTerm = term;

      this.searchService.currentBuyingWindowId =
        this.orderService.currentOrderWindowId;

      this.searchService
        .productsSearch({ useSearchFilters: true })
        .pipe(untilDestroyed(this))
        .subscribe((result) => {
          if (!result.failed && result.count === 0 && result.hits === 0) {
            this.googleAnalytics.headerSearchNoResults(term, orderType, page);
          }
        });

      this.googleAnalytics.searchTerm(
        this.searchText,
        this.orderService.activeOrder
      );

      if (!this.isSearchResultPage) {
        this.router.navigate(['/search-results']).then(() => {});
      }
    }

    if (this.searchText === '') {
      this.searchService.clearSearchResults();
    }
  }

  get isSearchResultPage(): boolean {
    return this.router.url.indexOf('search-result') !== -1;
  }

  get selectedOrderType(): string {
    return this.orderService.currentOrderType || OrderTypes.ECOMMERCE_TYPE;
  }

  // should be present for ng-model binding
  set selectedOrderType(val: string) {}
}
